var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7468_144816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.9496C18.0327 18.3126 23.3825 15.8814 23.6136 10.7669C23.6206 10.6527 23.625 10.5376 23.625 10.4216C23.625 7.27458 21.1316 4.72461 18.0554 4.72461C16.1719 4.72461 14.5071 5.68312 13.5 7.14775C12.4919 5.68302 10.8281 4.72461 8.94375 4.72461C5.86755 4.72371 3.375 7.27458 3.375 10.4216C3.375 10.5358 3.37939 10.6491 3.38555 10.7615C3.60967 15.8751 8.85582 18.1986 13.5 22.9496Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 9.95703L18.7283 13.3289",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7285 9.95703L15.3566 13.3289",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7468_144816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAngry);
export default __webpack_public_path__ + "static/media/heart-angry.d40b6637e3adbe33ca4c4920d9db4d70.svg";
export { ForwardRef as ReactComponent };